<template>
  <!-- *RPD MHOR  Appv 0.91
* Copyright (c) 2025, Blue Cover Six LLC . John Molt. All rights reserved.
Code licensed under contract To Reno Police Department / City of Reno, in perpetuity -->

  <div id="add-edit-home" class="mt-5">
    <h2 color="white" style="width: 100%; text-align: center">
      Mental Health Online Registration
    </h2>
    <h3 class="light-blue--text" style="width: 100%; text-align: center">
     A CITY OF RENO RESOURCE
    </h3>
    <h4 class="mt-4">Confidentiality Statement</h4>
    <p>
      The Reno Police Department Mental Health Online Registry is a voluntary
      program to help officers and clinicians respond safely and effectively
      during a crisis or call for service. Information provided will be kept
      confidential within the Reno Police Department and used only to support
      public safety and crisis response. While the registry is not a medical
      record and not subject to HIPAA, all information will be treated with the
      same level of privacy and security protections required by HIPAA.
      Information will not be shared outside of RPD unless required by law.
    </p>
    <h3 v-if="show_edit_label">Editing</h3>
    <template>
      <v-form ref="form" dark v-model="valid" lazy-validation>
        <v-container fluid id="form-container">

            <v-row dense v-if="isEdit && admin">
              <v-col cols="12" md="4">
                <v-select
                
                  dark
                  color="white"
                  attach
                  v-model="reg.approved"
                  :items="['No', 'Yes']"
                  label="Approved"
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
              <v-checkbox
                v-model="reg.rec_disp_email"
                label="Sent Rec./Disp Email"
                color="white"
                hide-details
                readonly
              ></v-checkbox>
              </v-col>
            </v-row>
            <v-row dense class="mt-3"  v-if="isEdit && admin">
              <v-col cols="12" md="12">
                <label>Admin Notes</label>
                <v-textarea
                color="white"
                v-model="reg.notes"
                outlined
                auto-grow                
                :rows="3"
                :counter="8000"
                :maxlength="8000"
                />
              </v-col>
            </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                color="white"
                dark
                maxlength="60"
                v-model="reg.fname"
                :counter="60"
                :rules="rule60"
                label="First Name"
                required
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="white"
                dark
                maxlength="60"
                v-model="reg.lname"
                :counter="60"
                :rules="rule60"
                label="Last Name"
                required
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <date_field label="DOB" v-model="reg.dob"></date_field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="white"
                dark
                maxlength="120"
                v-model="reg.email"
                :counter="120"
                :rules="emailRulesOpt"
                label="Email"
              ></v-text-field
            ></v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-mask="'###-###-####'"
                color="white"
                dark
                maxlength="12"
                v-model="reg.phone"
                :counter="12"
                label="Phone"
                placeholder="###-###-####"
                :rules="phoneRules2"
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="white"
                dark
                maxlength="120"
                v-model="reg.address"
                :counter="120"
                :rules="rule120"
                label="Address"
                required
              ></v-text-field
            ></v-col>
          </v-row>
          <!-- *************************** row 4 -->
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                color="white"
                dark
                maxlength="60"
                v-model="reg.prim_lang"
                :counter="60"
                label="Primary language"
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="6">
              <v-text-field
                color="white"
                dark
                maxlength="60"
                v-model="reg.gender"
                :counter="60"
                label="Gender"
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row dense>
          <v-col cols="12">
            <v-select
              dark
              color="white"
              attach
              v-model="reg.completed_by"
              :items="[
                'Self',
                'Spouse / Partner',
                'Parent',
                'Guardian',
                'Grandparent',
                'Sibling',
                'Caregiver',
                'Friend',
                'Case Manager',
                'Clinician / Doctor',
               
              ]"
              :rules="requiredRule"
              label="Completed By"
              required
            ></v-select>
          </v-col>
          </v-row>
          <!-- Emergency Contact information: Name, Relationship, Phone # -->
          <h4 class="mt-5">Emergency Contact Information (ECI)</h4>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                color="white"
                dark
                maxlength="120"
                v-model="reg.eci_name"
                :counter="120"
                label="ECI Name"
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="3">
              <v-select
                dark
                color="white"
                attach
                v-model="reg.eci_rltnshp"
                :items="[
                  'Spouse',
                  'Parent',
                  'Guardian',
                  'Grandparent',
                  'Sibling',
                  'Caregiver',
                  'Friend',
                ]"
                label="Relationship"
              ></v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-mask="'###-###-####'"
                color="white"
                dark
                maxlength="12"
                v-model="reg.eci_phone"
                :counter="12"
                label="Phone"
                placeholder="###-###-####"
                :rules="phoneRules2"
              ></v-text-field
            ></v-col>
          </v-row>

          <v-row dense class="mt-5">
            <v-col cols="12" md="12">
              <v-select
                dark
                color="white"
                attach
                v-model="reg.weapons"
                :items="['No', 'Yes']"
                label="Are there any weapons in the home?"
              ></v-select>
            </v-col>
          </v-row>

          <v-row dense v-if="reg.weapons === 'Yes'">
            <v-col cols="12" md="12">
              <label>If yes, please describe the weapons in the home</label>
              <v-textarea
                color="white"
                v-model="reg.weapons_desc"
                outlined
                auto-grow
                :rows="3"
                :counter="1000"
                :maxlength="1000"
              />
            </v-col>
          </v-row>
          <!-- Mental Health ************************** -->
          
          <v-row dense class="mt-3">
            <v-col cols="12" md="12">
              <label>Mental Health History</label>
              <v-textarea
                color="white"
                v-model="reg.mental_health"
                outlined
                auto-grow
                :rows="3"
                :counter="2000"
                :maxlength="2000"
            /></v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12" md="12">
              <label>Substance Use</label>
              <v-textarea
                color="white"
                v-model="reg.substance"
                outlined
                auto-grow
                :rows="3"
                :counter="2000"
                :maxlength="2000"
            /></v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12" md="12">
              <label>Medications</label>
              <v-textarea
                color="white"
                v-model="reg.medications"
                outlined
                auto-grow
                :rows="3"
                :counter="2000"
                :maxlength="2000"
            /></v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12" md="12">
              <label
                >History of Hospitalization for mental health/substance
                use</label
              >
              <v-textarea
                color="white"
                v-model="reg.history"
                outlined
                auto-grow
                :rows="3"
                :counter="8000"
                :maxlength="8000"
            /></v-col>
          </v-row>

          <h4 class="">Counselor</h4>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                color="white"
                dark
                maxlength="60"
                v-model="reg.cnsl_name"
                :counter="60"
                label="Name"
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-mask="'###-###-####'"
                color="white"
                dark
                maxlength="12"
                v-model="reg.cnsl_phone"
                :counter="12"
                label="Phone"
                placeholder="###-###-####"
                :rules="phoneRules2"
              ></v-text-field
            ></v-col>
          </v-row>
          <h4 class="">Psychiatrist</h4>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                color="white"
                dark
                maxlength="60"
                v-model="reg.psych_name"
                :counter="60"
                label="Name"
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-mask="'###-###-####'"
                color="white"
                dark
                maxlength="12"
                v-model="reg.psych_phone"
                :counter="12"
                label="Phone"
                placeholder="###-###-####"
                :rules="phoneRules2"
              ></v-text-field
            ></v-col>
          </v-row>
          <!--  General *********************** -->

          <h4 class="mt-5">General</h4>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                color="white"
                dark
                maxlength="60"
                v-model="reg.hospital"
                :counter="60"
                label="Preferred Hospital"
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="6">
              <v-select
                dark
                color="white"
                item-color="white"
                attach
                multiple
                v-model="reg.triggers"
                :items="['Loud Noises', 'Physical Touch', 'Bright Lights']"
                label="Known triggers"
              ></v-select>
            </v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12" md="12">
              <label>Other Triggers</label>
              <v-textarea
                color="white"
                v-model="reg.triggers_other"
                outlined
                auto-grow
                :rows="3"
                :counter="8000"
                :maxlength="8000"
            /></v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12" md="12">
              <label>Helpful de-escalation strategies</label>
              <v-textarea
                color="white"
                v-model="reg.de_escalation"
                outlined
                auto-grow
                :rows="3"
                :counter="8000"
                :maxlength="8000"
            /></v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12" md="12">
              <label>Things to try and avoid with me</label>
              <v-textarea
                color="white"
                v-model="reg.avoid"
                outlined
                auto-grow
                :rows="3"
                :counter="8000"
                :maxlength="8000"
            /></v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                color="white"
                dark
                maxlength="60"
                v-model="reg.toy"
                :counter="60"
                label="Any favorite toy or object"
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="6">
              <v-select
                dark
                color="white"
                attach
                v-model="reg.response"
                :items="['Call provider', 'Call Emergency contact', 'Hospital transport']"
                label="Preferred response when in a crisis"
              ></v-select>
            </v-col>
          </v-row>

          <v-row dense class="mt-3">
            <v-col cols="12" md="12">
              <v-select
                dark
                color="white"
                attach
                v-model="reg.violence"
                :items="['No', 'Yes']"
                :rules="requiredYesNo"
                label="Any history of aggression or violence?"
                required
              ></v-select>
            </v-col>
          </v-row>

          <v-row dense v-if="reg.violence === 'Yes'">
            <v-col cols="12" md="12">
              <label>If yes, please provide an example</label>
              <v-textarea
                color="white"
                v-model="reg.violence_example"
                outlined
                auto-grow
                :rows="3"
                :counter="8000"
                :maxlength="8000"
                :rules="requiredYesNo"
                required
              />
            </v-col>
          </v-row>
           <v-row dense class="mt-3">
           <v-col cols="12" md="12">
              <label>Pets or service animals?</label>
              <v-textarea
                color="white"
                v-model="reg.pets"
                outlined
                auto-grow
                :rows="3"
                :counter="8000"
                :maxlength="8000"
            /></v-col>
          </v-row>
          <v-row dense
            ><v-col cols="12" md="3">
              <v-btn color="grey darken-1" class="btn-size" @click="save">
                SAVE FORM
              </v-btn></v-col
            >
            <v-col cols="12" md="3">
              <v-btn
                class="btn-size"
                v-if="show_edit_label"
                color="grey darken-1 "
                @click="submit_rec(reg)"
              >
                DISPATCH & RECORDS
              </v-btn></v-col
            >
            <v-col cols="12" md="3">
              <v-btn
                class="btn-size"
                v-if="show_edit_label"
                color="grey darken-1 "
                @click="archive"
              >
               ARCHIVE
              </v-btn></v-col
            >
            <v-col cols="12" md="3">
              <v-btn
                class="btn-size"
                v-if="show_edit_label"
                color="grey darken-1 "
                @click="cancel"
              >
                CANCEL EDIT
              </v-btn></v-col
            ></v-row
          >
        </v-container>
      </v-form>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.v-select-list {
  background-color: #2e2e2e !important; /* pick your special gray */
}
/* Base: 0px and up (default styles) */
@media (min-width: 0px) {
  .btn-size {
    width: 100%;
  }
}

/* Breakpoint: 768px and up */
@media (min-width: 768px) {
  .btn-size {
    width: 200px;
  }
  .marg-l {
    margin-left: 0px;
  }
}
.approved-dropdown .v-list-item {
  opacity: 1 !important;
}

.approved-dropdown .v-list-item__title {
  color: black !important;
}
:deep(.approved-dropdown .v-list-item)
{
    opacity: 1 !important;
    color:white;
}

::v-deep .v-list-item__title{
color:white !important;
}
:deep(.v-list-item__title){
  color:white !important;
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
import date_field from "./date_field.vue";
export default {
  name: "add_edit",
  mixins: [bus_common],
  components: { date_field },
  props: ["current_edit", "show_edit_label"],
  data: function () {
    return {
      item: "item-true",
      valid: true,
      approved: "No",
      reg: {
        registrationId: 0,
        approved: "No",
        fname: "",
        lname: "",
        email: "",
        dob: null,
        address: "",
        phone: "",
        gender: "",
        completed_by: "",
        prim_lang: "",
        eci_name: "",
        eci_rltnshp: "",
        eci_phone: "",
        weapons: "",
        weapons_desc: "",
        cnsl_name: "",
        cnsl_phone: "",
        psych_name: "",
        psych_phone: "",
        hospital: "",
        history: "",
        medications: "",
        triggers: [],
        de_escalation: "",
        avoid: "",
        toy: "",
        response: "",
        violence: "",
        violence_example: "",
        pets: "",
        substance: "",
        triggers_other: "",
        notes: "",
        mental_health:"",
      },
      reg_new: {
        registrationId: 0,
        approved: "No",
        fname: "",
        lname: "",
        email: "",
        dob: null,
        address: "",
        phone: "",
        gender: "",
        completed_by: "",
        prim_lang: "",
        eci_name: "",
        eci_rltnshp: "",
        eci_phone: "",
        weapons: "",
        weapons_desc: "",
        cnsl_name: "",
        cnsl_phone: "",
        psych_name: "",
        psych_phone: "",
        hospital: "",
        history: "",
        medications: "",
        triggers: [],
        de_escalation: "",
        avoid: "",
        toy: "",
        response: "",
        violence: "",
        violence_example: "",
        pets: "",
        substance: "",
        triggers_other: "",
        notes: "",
        mental_health:"",
      },
      reg_dev: {
        registrationId: 0,
        approved: "No",
        fname: "Jiminy",
        lname: "Cricket",
        email: "ant@gmail.com",
        dob: "1963-11-02",
        address: "55 There St.",
        phone: "702-123-1234",
        gender: "Furry Type",
        completed_by: "Friend",
        prim_lang: "English",
        eci_name: "Mary Wolf",
        eci_rltnshp: "Wife",
        eci_phone: "775-312-4321",
        weapons: "Yes",
        weapons_desc: "FGM-148 Javelin,M134 Minigun,M2 Browning,Mk 19 grenade launcher",
        cnsl_name: "Shelia Talk",
        cnsl_phone: "775-312-3421",
        psych_name: "Dr. Ed Zoom",
        psych_phone: "775-321-1234",
        hospital: "St. Mercy",
        history: "Gary con RPGs, just awful",
        medications: "GLP-1 through 9.",
        triggers: ["Loud Noises", "Physical Touch", "Bright Lights"],
        de_escalation: "Lie to me.",
        avoid: "Politcs",
        toy: "Swing Set",
        response: "Call Emergency contact",
        violence: "Yes",
        violence_example: "OW! OW! OW! OW! OW! ",
        pets: "Krypto",
        substance: "Patato Starch",
        triggers_other: "flipping off",
         notes: "Admin notes",
         mental_health:"narcolepsy, addiction to comic books",
      },
      name: "",
      requiredRule: [
        (v) => !!v || "Field is required",
      ],
        requiredYesNo: [
           (v) => !!v || "Field is required",
        ],
      rule60: [
        (v) => !!v || "Field is required",
        (v) => (v && v.length <= 60) || "Name must be less than 60 characters",
      ],
      rule120: [
        (v) => !!v || "Field is required",
        (v) =>
          (v && v.length <= 120) || "Name must be less than 120 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      emailRulesOpt: [
        (v) => !v || /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      phoneRules: [
        (v) => /^\d{3}-\d{3}-\d{4}$/.test(v) || "Phone must be valid",
      ],
      phoneRules2: [
        (v) =>
          !v ||
          v === "" ||
          /^\d{3}-\d{3}-\d{4}$/.test(v) ||
          "Phone must be valid",
      ],

      select: null,
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,
    };
  },
 
watch: {
  current_edit: {
    immediate: true,
    handler(val) {
      if (!val) return;

      const copy = this.mno(val);
      copy.dob = this.format_date_sql(copy.dob);

      if (!copy.approved) copy.approved = "No";

      this.reg = copy;
    }
  },
 "reg.completed_by": function (val, oldVal) {
  if (!this.reg) return;
  if (this.isEdit) return;

  if (val === "Guardian" && oldVal !== "Guardian") {
    this.swall_it(
      "Guardianship Required",
      "If you select 'Guardian', you must have official guardianship paperwork available for review.",
      "warning",
      null,
      null
    );
  }
},
  "reg.eci_rltnshp": function (val, oldVal) {
    if (!this.reg) return;

    if (val === "Guardian" && oldVal !== "Guardian") {
      this.swall_it(
        "Guardianship Required",
        "If you select 'Guardian', you must have official guardianship paperwork available for review.",
        "warning",
        null,
        null
      );
    }
  },
  "reg.weapons": function (val) {
    if (!this.reg) return;

    if (val !== "Yes") {
      this.reg.weapons_desc = "";
    }
  },

  "reg.violence": function (val) {
    if (!this.reg) return;

    if (val !== "Yes") {
      this.reg.violence_example = "";
    }
  }
},
  "reg.weapons": function (val) {
    if (!this.reg) return;

    if (val !== "Yes") {
      this.reg.weapons_desc = "";
    }
  },

  "reg.violence": function (val) {
    if (!this.reg) return;

    if (val !== "Yes") {
      this.reg.violence_example = "";
    }
  },

  
  computed: {
    admin: function () {
      return this.$store.state.user.roles.indexOf("mhor-admin") > -1;
    },

  isEdit() {
    return this.reg && this.reg.registrationId > 0;
  }

  },

  methods: {


    archive(reg) {
      this.show_loader(true);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.registrationId = this.reg.registrationId;

      formIn.apiname = "archive";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
      
          this.swall_it("Record Status", "Archived", "success", null, null);
          this.cancel();
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error send email", msg.msg, "error", null, null);
        });
    },
    submit_rec(reg) {
      this.show_loader(true);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.registrationId = this.reg.registrationId;

      formIn.apiname = "submit_rec";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          //console.log("msg???");
          this.swall_it("Email Status", "Email Sent", "success", null, null);
           this.cancel();
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error send email", msg.msg, "error", null, null);
        });
    },
      save() {
        // validate
        this.show_loader(true);
        //console.log("SAVE this.reg =", this.reg);
        //console.log("SAVE this.reg.weapons =", this.reg.weapons);
        //console.log("SAVE this.reg.weapons_desc =", this.reg.weapons_desc);
        //console.log("SAVE payload json =", JSON.stringify(this.reg, null, 2));

        if (this.$refs.form.validate() == false) {
          this.swall_it(
            "Submit Form Status",
            "There's an error in one or more Fields. Please address the problem in the red marked fields.",
            "warning",
            null,
            null
          );
          return;
        }

        

        const isEditSave = this.current_edit != null;

        // Deep copy using your utility
        const regOut = this.mno(this.reg);

        // Safe transform on the copy only
        if (Array.isArray(regOut.triggers)) {
          regOut.triggers = regOut.triggers.join(",");
        }

        const formIn = {
          email: this.$store.state.user.email,
          token: this.$store.state.user.token,
          reg: regOut,
          apiname: "save"
        };

        //console.log("SAVE formIn =", formIn);
        //console.log("SAVE formIn json =", JSON.stringify(formIn, null, 2));

        this.$store
          .dispatch("anyapi", formIn)
          .then((data) => {
            this.show_loader(false);

            if (isEditSave) {
              this.$emit("update", data);
              return;
            }

            // Only for ADD mode
            this.reg = this.mno(this.reg_new);

            this.swall_it(
              "Save Status",
              "Thank you for your submission. Your information was received and will be reviewed.<br> Your reference number is #" +
                this.prepend100(data.registrationId) +
                " . Please make a note of it.",
              "success",
              null,
              null
            );

            this.$nextTick(() => {
              if (this.$refs.form) {
                this.$refs.form.resetValidation();
              }
            });
          })
          .catch((msg) => {
            this.dialog = false;
            this.show_loader(false);
            this.swall_it("Error search", msg.msg, "error", null, null);
          });
      },
    prepend100(num) {
      return "100" + String(num);
    },

    cancel() {
      this.$emit("cancel_edit");
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
init: function () {
  if (!this.current_edit) {
    this.reg = this.mno(this.reg_new);
  }
}
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>

<style scoped></style>
